/* eslint-disable func-names */
import {
  ADD_PROPERTY,
  UPDATE_PROPERTY,
  DELETE_PROPERTY,
  CANCEL_REQUEST,
  FETCH_PROPERTY_TYPES,
  FETCH_OPEN_WORKORDERS,
  UPLOAD_PROPERTY_TYPES,
  CLEAR_PROPERTY_ACTION,
  FETCH_SCHEMA,
  UPDATE_SCHEMA,
  CLEAR_MAINTENANCE,
  FETCH_CATEGORIES,
  UPDATE_CATEGORIES,
  ADD_CATEGORIES,
  FETCH_WORKORDERS,
  ADD_WORKORDERS,
  GET_WORKORDER,
  ADD_MAINTENANCE,
  FETCH_ALL_TYPES,
  FETCH_ALL_LOCATIONS,
  UPLOAD_TYPES,
  CLEAR_TENANT_TYPES,
  CLEAR_CREATE_ACTION
} from './types';

import { actionForState } from '../../../utils/helpers';

const INITIAL_STATE = {
  error: {},
  action: {
    loading: false,
    success: undefined
  },
  createAction: {
    success: false,
    loading: false,
    error: false
  },
  updateAction: {
    success: false,
    loading: false,
    error: false
  },
  locationsAction: {
    success: false,
    loading: false,
    error: false
  },
  deleteAction: {
    success: false,
    loading: false,
    error: false
  },
  cancelRequest: {
    success: false,
    loading: false,
    error: false
  },
  allClosedWorkOrders: {},
  allWorkOrders: [],
  allCategories: [],
  createWorkorderAction: { success: false, error: false, loading: false },
  fetchSchemaAction: { success: false, error: false, loading: false }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PROPERTY.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case ADD_PROPERTY.success:
      return {
        ...state,
        createAction: actionForState(state.action, 'success')
      };
    case ADD_PROPERTY.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case UPDATE_PROPERTY.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case UPDATE_PROPERTY.success:
      return {
        ...state,
        updateAction: actionForState(state.action, 'success')
      };
    case UPDATE_PROPERTY.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case DELETE_PROPERTY.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case DELETE_PROPERTY.success:
      return {
        ...state,
        deleteAction: actionForState(state.action, 'success')
      };
    case DELETE_PROPERTY.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case CANCEL_REQUEST.pending:
      return {
        ...state,
        cancelRequest: actionForState(state.action, 'pending')
      };
    case CANCEL_REQUEST.success:
      return {
        ...state,
        cancelRequest: actionForState(state.action, 'success'),
        cancelData: action.payload
      };
    case CANCEL_REQUEST.error:
      return {
        ...state,
        cancelRequest: actionForState(state.action, 'error')
      };
    case FETCH_OPEN_WORKORDERS.pending:
      return {
        ...state,
        locationsAction: actionForState(state.action, 'pending')
      };
    case FETCH_OPEN_WORKORDERS.success:
      return {
        ...state,
        locationsAction: actionForState(state.action, 'success'),
        openWorkOrders: action.payload
      };
    case FETCH_OPEN_WORKORDERS.error:
      return {
        ...state,
        locationsAction: actionForState(state.action, 'error')
      };
    case FETCH_PROPERTY_TYPES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_PROPERTY_TYPES.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        allTypes: action.payload
      };
    }
    case FETCH_PROPERTY_TYPES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case UPLOAD_PROPERTY_TYPES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case UPLOAD_PROPERTY_TYPES.success: {
      return {
        ...state,
        saveAction: actionForState(state.action, 'success'),
        allTypes: action.payload
      };
    }
    case UPLOAD_PROPERTY_TYPES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case FETCH_SCHEMA.pending:
      return {
        ...state,
        fetchSchemaAction: actionForState(state.action, 'pending')
      };
    case FETCH_SCHEMA.success: {
      return {
        ...state,
        fetchSchemaAction: actionForState(state.action, 'success'),
        leaseMaintenance_schema: action.payload
      };
    }
    case FETCH_SCHEMA.error:
      return {
        ...state,
        fetchSchemaAction: actionForState(state.action, 'error')
      };
    case UPDATE_SCHEMA.success: {
      return {
        ...state,
        schemaAction: actionForState(state.action, 'success')
      };
    }
    //  Reducer to store the fetch Categories function
    case FETCH_CATEGORIES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_CATEGORIES.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        allCategories: action.payload
      };
    }
    case FETCH_CATEGORIES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };

    case ADD_CATEGORIES.success: {
      return {
        ...state,
        createCategoryAction: actionForState(state.action, 'success'),
        addedCategory: action.payload
      };
    }
    case UPDATE_CATEGORIES.success: {
      return {
        ...state,
        updateCategoryAction: actionForState(state.action, 'success'),
        updatedCategory: action.payload
      };
    }
    case FETCH_WORKORDERS.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_WORKORDERS.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        allWorkOrders: action.payload
      };
    }
    case FETCH_WORKORDERS.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case ADD_WORKORDERS.pending:
      return {
        ...state,
        createWorkorderAction: { loading: true, success: false, error: false }
      };
    case ADD_WORKORDERS.success: {
      return {
        ...state,
        createWorkorderAction: { loading: false, success: true, error: false },
        createdWorkorder: action.payload
      };
    }
    case ADD_WORKORDERS.error:
      return {
        ...state,
        createWorkorderAction: { loading: false, success: false, error: true }
      };
    case GET_WORKORDER.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case GET_WORKORDER.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        leaseWorkorder: action.payload
      };
    }
    case GET_WORKORDER.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case ADD_MAINTENANCE.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case ADD_MAINTENANCE.success: {
      return {
        ...state,
        MaintenanceAction: actionForState(state.action, 'success'),
        LeaseMaintenance: action.payload
      };
    }
    case ADD_MAINTENANCE.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case FETCH_ALL_TYPES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_ALL_TYPES.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        allTenantTypes: action.payload
      };
    }
    case FETCH_ALL_TYPES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
      // FETCH_ALL_LOCATIONS
    case FETCH_ALL_LOCATIONS.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case FETCH_ALL_LOCATIONS.success: {
      return {
        ...state,
        action: actionForState(state.action, 'success'),
        locations: action.payload
      };
    }
    case FETCH_ALL_LOCATIONS.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case UPLOAD_TYPES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case UPLOAD_TYPES.success: {
      return {
        ...state,
        uploadAction: actionForState(state.action, 'success'),
        uploadedTypes: action.payload
      };
    }
    case UPLOAD_TYPES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case CLEAR_MAINTENANCE:
      return {
        ...state,
        leaseMaintenance_schema: {},
        schemaAction: {},
        MaintenanceAction: {},
        leaseWorkorder: {},
        createCategoryAction: {},
        updateCategoryAction: {}
      };

    case CLEAR_CREATE_ACTION:
      return {
        ...state,
        createWorkorderAction: { loading: false, success: false, error: false }
      };
    case CLEAR_PROPERTY_ACTION:
      return {
        ...state,
        createAction: {
          success: false, loading: false, error: false
        },
        deleteAction: {
          success: false, loading: false, error: false
        },
        updateAction: {
          success: false, loading: false, error: false
        },
        allTypes: undefined,
        saveAction: {},
        action: {
          loading: false,
          success: undefined
        },
        createWorkorderAction: {
          success: false, loading: false, error: false
        },
        fetchSchemaAction: {
          success: false, loading: false, error: false
        }
      };
    case CLEAR_TENANT_TYPES:
      return {
        ...state,
        uploadAction: {
          success: false,
          loading: false,
          message: ''
        }
      };
    default:
      return state;
  }
}
